<template>
	<lv-column-text :align="align"
					:link="link"
					:row="showRow"
					:row-index="rowIndex"
					:field="field"
					:editable="lv_editable"
					:data-type="dataType"
					:tooltip="tooltip">
		<slot :row="row" :rowIndex="rowIndex" :align="align" :field="field" :editable="lv_editable">
			<link-radio
				v-if="!fixedRow"
				:value="cacheIndex > -1"
				readonly
				@click.native.stop="handleRowClick"

				:size="size"
				:color="color"
				:active-icon="activeIcon"
				:inactive-icon="inactiveIcon"
				:active-color="activeColor"
				:inactive-color="inactiveColor"/>
		</slot>
	</lv-column-text>
</template>

<script>
	import {ColumnItemMixin} from '../mixins';
	import LinkRadio from '../../radio/link-radio';
	import {findComponentUpward} from '../../../utils/dom';
	import LvColumnText from '../lv-column-text';
	import {getSelectIndex} from "./index";

	export default {
		name: 'link-table-column-check-item',
		components: {LvColumnText, LinkRadio},
		mixins: [ColumnItemMixin],
		props: {
			toggleOnClickRow: {type: Boolean, default: false},
			singleSelect: {type: Boolean},
			selectRows: {type: Array},
			beforeCheck: {type: Function},

			size: {default: 'large'},
			color: {default: 'primary'},
			activeIcon: {type: String},
			inactiveIcon: {type: String},
			activeColor: {type: String},
			inactiveColor: {type: String}
		},
		data() {
			return {
				table: null,
			};
		},
		created() {
			if (this.rowIndex == null && this.colIndex == null) return;
			this.$emit('created', this);
			if (Boolean(this.toggleOnClickRow)) {
				this.table = findComponentUpward(this, 'lv-base-table');
				if (this.table) {
					this.table.$on('rowClick', ({row}) => row.row === this.row && this.handleRowClick());
				}
			}
		},
		beforeDestroy() {
			this.$emit('beforeDestroy', this);
		},
		computed: {
			cacheIndex() {
				return getSelectIndex(this.selectRows, this.row)
			},
		},
		methods: {
			handleRowClick() {
				this.$emit('toggle-check', this.row)
			},
		}
	};
</script>
